module.exports = __webpack_public_path__ + "static/media/strategic-planning.0a1fb230.jpg";